import { Card, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicAPIImage } from "../../../Utils";
import { useState } from "react";

import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { CompanyInfoSection } from "./CompanyInfoSection";
import UpdateLogoModal from "../../UiKits/Modal/ClientProfile/Update/UpdateCompanyLogo";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const CompanyData = ({ companyInfo }: CompanyDataProps) => {
  const [CompanyLogoModal, setModal] = useState(false);
  const toggleLogo = () => setModal(!CompanyLogoModal);

  return (
    <Col sm="12">
      <Card className="hovercard text-center user-profile-card">
        <div className="cardheader"></div>
        <div className="user-image">
          <div className="avatar">
            <Image
              alt={`${companyInfo?.company}`}
              src={dynamicAPIImage(`${companyInfo?.logo_url}`)}
              style={{ width: 200, height: 200, objectFit: "cover" }}
            />
          </div>
          <div className="icon-wrapper">
            <i
              className="icofont icofont-camera"
              onClick={toggleLogo}
            ></i>

            {
              <UpdateLogoModal
                toggle={toggleLogo}
                modal={CompanyLogoModal}
                company_code={companyInfo?.code || ""}
              />
            }
          </div>
        </div>
        <div className="info">
          <CompanyInfoSection companyInfo={companyInfo} />
        </div>
      </Card>
    </Col>
  );
};

export default CompanyData;
